/*
 * @Description: 提示封装
 */

import { translate } from './i18n/index.js';

// ---------------------------------------------------------------------------

/**
 * 全局提示
 * @param {*} content
 * @param {*} title
 * @param {*} showCancel
 * @param {*} confirmText 
 */
const showModal = (content, title = getApp().translate('SYSTEM_PROMPT'), showCancel = false, confirmText = getApp().translate('OK'), success, fail, complete) => {
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	const cancelText= getApp().translate('CANCEL');
	uni.showModal({
		title,
		content,
		confirmText,
		showCancel,
		cancelText,
		success,
		fail,
		complete
	})
}

// ---------------------------------------------------------------------------

/**
 * 轻提示（成功）
 * @param {*} title 
 * @param {*} icon 
 */
const showSuccTip = (title, icon = 'success', success, fail, complete) => {
	if (typeof title !== 'string') {
		title = JSON.stringify(title);
	}
	uni.showToast({ title, icon, success, fail, complete });
}

/**
 * 轻提示（失败）
 * @param {*} title 
 * @param {*} icon 
 */
const showFailTip = (title, icon = 'error', success, fail, complete) => {
	if (typeof title !== 'string') {
		title = JSON.stringify(title);
	}
	uni.showToast({ title, icon, success, fail, complete });
}

/**
 * 轻提示（通用）
 * @param {*} title 
 * @param {*} icon 
 */
const showToast = (title, icon = 'none', success, fail, complete) => {
	if (typeof title !== 'string') {
		title = JSON.stringify(title);
	}
	uni.showToast({ title, icon, success, fail, complete });
}

// ---------------------------------------------------------------------------

export default {
	value: {},
	method: {
		showModal,
		showSuccTip,
		showFailTip,
		showToast,
	}
};